import { render, staticRenderFns } from "./ModifyPriceListProposal.vue?vue&type=template&id=3a67abb7"
import script from "./ModifyPriceListProposal.vue?vue&type=script&lang=js"
export * from "./ModifyPriceListProposal.vue?vue&type=script&lang=js"
import style0 from "./ModifyPriceListProposal.vue?vue&type=style&index=0&id=3a67abb7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports